import { gql } from '@apollo/client';

export const REPORTING_REQUIREMENT_OPTIONS = gql`
  query reportingRequirementOptions {
    options: reportingRequirementOptions {
      items {
        id
        name
        type
        frequency
        frequencyLabel
      }
      associations {
        id
        name
        type
      }
      reporters {
        id
        name
        type
      }
    }
  }
`;
